import React, {useEffect, useState} from 'react';
import { AnimatePresence, motion } from "framer-motion"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGem, faArrowUpFromBracket, faCircleCheck, faCircleDot, faAngleDown, faAngleUp, faPlus} from '@fortawesome/free-solid-svg-icons';
import { FilterMaker, Paginator, UXHelper, VideoLoader } from '../components/UXHelper';
import { ModalBtn, ModalNotify } from '../components/Modals';
import { LoadAccountStakedMinerals } from '../components/feactures/dataFetcher'; 
import { ExtinctionVideoData, ExtinctionData, ItemsData, ApisProvider } from '../components/feactures/dataProvider';
import './styles/workshop.css';
import { LayoutCol, LayoutContainer, LayoutRow } from './layouts/layout_bi_columns';
import { ItemsScrapyard } from '../components/Items';
import { LoadisScrap, LoadWorkshopData} from '../components/feactures/dataFetcher';
import { InventoryParts } from './Inventory';

export const Workshops = ({ userData, showLoader, closerLoader}) => {


  if(!userData.isConnected){
    return (
      <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }


  return (
    <LayoutContainer>
      <div className='container_lobbies'>
        <div className='title_lobby'>
          <h2>Choose a Workshop</h2>
        </div>
        <div className='lobby_inventory'>
          <UXHelper title={'Scrapyard'} url={"scrapyard"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_suits.webm"}/>
          <UXHelper title={`Workshop`} url={"billysworkshop"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menu_item_billys.webm"}/>
          <UXHelper title={'Alchemist'} url={"alchemist"} video={"https://extinctionwars.com/assets/videos/visuals/menu-items/menus_item_alchemist.webm"}/>
        </div>
      </div>
    </LayoutContainer>
  )
}

export const Alchemist = ({userData, onRefreshBalances, showLoader, closerLoader}) => {

  const [refreshData, setRefreshData] = useState(false);
  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  const [stakedBalances, setStakedBalances] = useState({
      neo: 0,
      neoFull: '0',
      chal: 0,
      chalFull: '0',
  })
  const [stakedpct, setStakedpct] = useState({
    neo: '0',
    chal: '0',
    onyx: '0',
    onyxpct: '0',
  })

  const [depositNeo, setDepositNeo] = useState(0);
  const [depositChal, setDepositChal] = useState(0);

  const [withdraw, setWithdraw] = useState(0);
  const [classShow, setClassShow] = useState('');
  const [recoverNeo, setRecoverNeo] = useState(0);
  const [recoverChal, setRecoverChal] = useState(0);

  const [errorMsg, setErrorMsg] = useState({
    notenough: '',
    exceeds: '',
  })

  useEffect(() => {
    
    if(userData.isConnected){
      if(refreshData){
        onRefreshBalances();
        loadStakedMinerals();
        setRefreshData(false);
      }
      loadStakedMinerals();
    }
    
  
    return () => {
      //
    }
  }, [(refreshData === true), userData.isConnected])

  const loadpct = (neo, chal) => {
    const pctNeo = (Number(neo) / 100) * 100;
    const pctChal = (Number(chal) / 100) * 100;
    
    const onyxProfit = (Number(neo) + Number(chal)) * 2;
    const onyxProfitpct = (onyxProfit / 400) * 100;
    
    setStakedpct({
      neo: pctNeo.toString(),
      chal: pctChal.toString(),
      onyx: onyxProfit.toString(),
      onyxpct: onyxProfitpct.toString(),
    })
  }

  const loadStakedMinerals = async() => {
    setStakedBalances({
      neo: 0,
      neoFull: '0',
      chal: 0,
      chalFull: '0',
    })

    setStakedpct({
      neo: '0',
      chal: '0',
      onyx: '0',
      onyxpct: '0',
    })

    LoadAccountStakedMinerals(userData.username)
    .then(x => {
      if(Number(x) !== 0){
        const nShort = Number.parseFloat(x.neodymium).toFixed(2);
        const cShort = Number.parseFloat(x.chalcedony).toFixed(2);
        setStakedBalances({
          neoFull: x.neodymium,
          neo: nShort,
          chalFull: x.chalcedony,
          chal: cShort,
        })
        
        loadpct(nShort, cShort);
      }else{
        setStakedBalances({
          neo: 0,
          neoFull: '0',
          chal: 0,
          chalFull: '0',
        })
      }
    })
  }

  const handlerCapture = (e) => {
    const result = e.target.value;
    const id = e.target.id;

    if(Number(id) === 1){
      // DEPOSITS
      setDepositNeo(result);
    }
    else if(Number(id) === 2){
      setDepositChal(result);
    }
    // WITHDRAWS
    else if(Number(id) === 3){
      setRecoverNeo(result);
    }
    else if(Number(id) === 4){
      setRecoverChal(result);
    }
  }

  const setMaxQty = (id) => {
    if(Number(id) === 1){
      setDepositNeo(Number(userData.userBalances.bShortNeo));
    }
    else if(Number(id) === 2){
      setDepositChal(Number(userData.userBalances.bShortChalce));
    }
    else if(Number(id) === 3){
      setRecoverNeo(Number(stakedBalances.neo));
    }
    else if(Number(id) === 4){
      setRecoverChal(Number(stakedBalances.chal));
    }
  }

  const depositMineral = async(id) => {
    if(Number(id) === 1){
      const qty = Number(depositNeo);

      if(userData.whichProvider === 'Anchor'){
        try{
          const action = {
            account: ExtinctionData.ONYX_CONTRACT,
            name: 'transfer',
            authorization: [userData.auths],
            data: {
              from: userData.username,
              to: ExtinctionData.GEARS_CONTRACT,
              quantity: `${qty}.0000 NEO`,
              memo: `deposit ${qty} Neo`,
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            
          setDepositNeo(0);
          pushRefresh();
          })
        }
        catch(err){
            
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        try{
          const action = {
              actions: [{
                  account: ExtinctionData.ONYX_CONTRACT,
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.GEARS_CONTRACT,
                    quantity: `${qty}.0000 NEO`,
                    memo: `deposit ${qty} Neo`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            setDepositNeo(0);
            pushRefresh();
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
    }
    else if(Number(id) === 2){
      const qty = Number(depositChal);

      if(userData.whichProvider === 'Anchor'){
        try{
          const action = {
            account: ExtinctionData.ONYX_CONTRACT,
            name: 'transfer',
            authorization: [userData.auths],
            data: {
              from: userData.username,
              to: ExtinctionData.GEARS_CONTRACT,
              quantity: `${qty}.0000 CHAL`,
              memo: `deposit ${qty} Chal`,
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          setDepositChal(0);
          pushRefresh();
          })
        }
        catch(err){
            
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        try{
          const action = {
              actions: [{
                  account: ExtinctionData.ONYX_CONTRACT,
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.GEARS_CONTRACT,
                    quantity: `${qty}.0000 CHAL`,
                    memo: `deposit ${qty} Chal`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            setDepositChal(0);
          pushRefresh();
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
    }
  }

  const recoverMineral = async(id) => {
    if(Number(id) === 3){
      const qty = Number(recoverNeo);

      if(userData.whichProvider === 'Anchor'){
        try{
          const action = {
            account: ExtinctionData.GEARS_CONTRACT,
            name: 'withdrawmine',
            authorization: [userData.auths],
            data: {
              account: userData.username,
              quantity: `${qty}.0000 NEO`,
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
            
          setRecoverNeo(0);
          setWithdraw(0);
          pushRefresh();
          })
        }
        catch(err){
            
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        try{
          const action = {
              actions: [{
                account: ExtinctionData.GEARS_CONTRACT,
                name: 'withdrawmine',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    account: userData.username,
                    quantity: `${qty}.0000 NEO`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            setRecoverNeo(0);
            setWithdraw(0);
            pushRefresh();
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
    }
    else if(Number(id) === 4){
      const qty = Number(recoverChal);

      if(userData.whichProvider === 'Anchor'){
        try{
          const action = {
            account: ExtinctionData.GEARS_CONTRACT,
            name: 'withdrawmine',
            authorization: [userData.auths],
            data: {
              account: userData.username,
              quantity: `${qty}.0000 CHAL`,
            },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);

          setRecoverChal(0);
          setWithdraw(0);
          pushRefresh();
          })
        }
        catch(err){
            
        }
      }
      else if(userData.whichProvider === 'WaxCloud'){
        try{
          const action = {
              actions: [{
                account: ExtinctionData.GEARS_CONTRACT,
                name: 'withdrawmine',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    account: userData.username,
                    quantity: `${qty}.0000 CHAL`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            setRecoverChal(0);
          setWithdraw(0);
          pushRefresh();
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
    }
  }

  const transmutation = async() => {
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
          account: ExtinctionData.GEARS_CONTRACT,
          name: 'fuseonyx',
          authorization: [userData.auths],
          data: {
            account: userData.username,
          },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
        //console.log(`Transaction broadcast! Id: ${transaction.id}`);
        pushRefresh();
        })
      }
      catch(err){
         
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      try{
        const action = {
            actions: [{
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'fuseonyx',
                authorization: [{
                    actor: userData.username,
                    permission: 'active',
                  }],
                data: {
                  account: userData.username,
                },
            }],
        }
        const transaction = await userData.sessionData.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 1200,
          });
          setNotify({
            status: true,
            error: false,
            title: 'Success',
            msg: 'Transaction Id:',
            txId: transaction.transaction_id,
          });
          pushRefresh();
      }
      catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
      }
    }
  }

  const pushRefresh = () => setRefreshData(true); 

  const pushWithdrawl = (id) => {
    if(Number(id) === 1){
      if(Number(withdraw) === 1){
        setWithdraw(0);
      }
      else{
        setWithdraw(id);
      }
      
    }
    else if(Number(id) === 2){
      if(Number(withdraw) === 2){
        setWithdraw(0);
      }
      else{
        setWithdraw(id);
      }
    }
  }

  const variant_DW = {
    initial: {
      x: '100px',
      opacity: 0,
    },
    show: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.2,
        delay: 0.5,
      }
    },
    exit: {
      opacity: 0,
    }
  }

  if(!userData.isConnected){
    return (
      <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }
  
  return(
    <div className='main_box_alchemist'>
      {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
      <div className='data_box_alchemist'>
        <div className='welcome_balances_box_alchemist'>
          <div className='welcome_box_alchemist'>
            <motion.h2
            initial={{scale: 0, opacity: 0}}
            animate={{scale: 1, opacity: 1}}
            transition={{duration: 0.2, delay: 0.2}}
            >Welcome, {userData.username}</motion.h2>
          </div>
          <motion.div className='balances_box_alchemist'
          initial={{x: '-100px', opacity: 0}}
          animate={{x: '0', opacity: 1}}
          transition={{duration: 0.2, delay: 0.4}}
          >
            <div className='icon_box_alchemist'>
              <FontAwesomeIcon icon={faGem} size='2xl' color='#dfdfdf'/>
            </div>
            <div className='info_balances_alchemist'>
              <p>Your Balances:</p>
              <span className='balances_alchemist'>{userData.userBalances.bShortOnyx} <span className='symbol_alchemist'>Onyx</span></span>
              <span className='balances_alchemist'>{userData.userBalances.bShortNeo} <span className='symbol_alchemist'>Neo</span></span>
              <span className='balances_alchemist'>{userData.userBalances.bShortChalce} <span className='symbol_alchemist'>Chal</span></span>
            </div>
          </motion.div>
        </div>
        <motion.div className='possible_profits_box_alchemist'
        initial={{x: '-100px', opacity: 0}}
        animate={{x: '0', opacity: 1}}
        transition={{duration: 0.2, delay: 0.5}}
        >
          <div>
            <div className='profit_title_alchemist'>
              <span>Estimated Results:</span>
              <span className='balances_alchemist'>{stakedpct.onyx} <span className='symbol_alchemist'>Onyx</span></span>
            </div>
            <div className='profits_bar_alchemist'>
              <div className='body_profit_bar_alchemist'>
                <span style={ {width: `${stakedpct.onyxpct}%`, height: '100%'}}></span>
              </div>
            </div>
          </div>
        </motion.div>
        <div className='staked_minerals_box_alchemist'>
          <div className='staked_title_alchemist'>
            <motion.span
            initial={{scale: 0, opacity: 0}}
            animate={{scale: 1, opacity: 1}}
            transition={{duration: 0.2, delay: 0.2}}
            >Your Minerals on Alchemist:</motion.span>
          </div>
          <div className='staked_balances_alchemist'>
            <motion.div className='staked_neo_box_alchemist' 
            initial={{y: '100px', opacity: 0}}
            animate={{y: '0', opacity: 1}}
            transition={{duration: 0.2, delay: 0.5}}
            >
              <div className='staked_logo_alchemist'>
                <span>N</span>
                <div><FontAwesomeIcon icon={faArrowUpFromBracket} className={`${(Number(stakedBalances.neo) === 100 || Number(withdraw) === 1) ? 'icon_deposit_withdraw deposit_icon' : 'icon_deposit_withdraw'}`} onClick={() => {
                  if(Number(stakedBalances.neo) !== 0){
                    pushWithdrawl(1)
                  }
                }}/></div>
              </div>
              <div className='staked_info_alchemist'>
                <span className='staked_mineral_title_alchemist'>Neodymium</span>
                <span className='staked_mineral_balance_alchemist'>{stakedBalances.neo} <span className='staked_balance_symbol_alchemist'>Neo</span></span>
              </div>
              <div className='staked_bar_alchemist'>
                <div className='body_staked_bar_alchemist'>
                  <span style={ {width: `${stakedpct.neo}%`, height: '100%'}}></span>
                </div>
              </div>
            </motion.div>
            <motion.div className='staked_chal_box_alchemist'
            initial={{y: '100px', opacity: 0}}
            animate={{y: '0', opacity: 1}}
            transition={{duration: 0.2, delay: 0.4}}
            >
              <div className='staked_logo_alchemist'>
                  <span>C</span>
                  <div><FontAwesomeIcon icon={faArrowUpFromBracket} className={`${(Number(stakedBalances.chal) === 100 || Number(withdraw) === 2) ? 'icon_deposit_withdraw deposit_icon' : 'icon_deposit_withdraw'}`} onClick={() => {
                    if(Number(stakedBalances.chal) !== 0){
                      pushWithdrawl(2)
                    }
                  }}/></div>
              </div>
              <div className='staked_info_alchemist' >
                <span className='staked_mineral_title_alchemist'>Chalcedony</span>
                <span className='staked_mineral_balance_alchemist'>{stakedBalances.chal} <span className='staked_balance_symbol_alchemist'>Chal</span></span>
              </div>
              <div className='staked_bar_alchemist'>
                <div className='body_staked_bar_alchemist'>
                  <span style={ {width: `${stakedpct.chal}%`, height: '100%'}}></span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <div className='form_box_alchemist'>
        <div className='form_header_box_alchemist'>
          <motion.h3 className='form_title_box_alchemist'
          initial={{scale: 0, opacity: 0}}
          animate={{scale: 1, opacity: 1}}
          transition={{duration: 0.2, delay: 0.2}}
          >Transmutation</motion.h3>
        </div>
        <AnimatePresence >
        {(Number(stakedBalances.neo) === 100 || Number(withdraw) === 1)
            ? <motion.div className='form_minerals_alchemist'
                initial='initial'
                animate='show'
                exit='exit'
                variants={variant_DW}
                key={1}
                
              >
                <div className='form_mineral_title_alchemist'>
                  <span>Withdraw Neodymium:</span>
                </div>
                <div className='form_inputs_minerals_alchemsit'>
                  <input id={3} type="number" placeholder='0 Neo' min={1} max={100} value={recoverNeo} onChange={handlerCapture}/>
                  <button className='btn_max_minerals_alchemist' onClick={() => setMaxQty(3)}>Max</button>
                </div>
                <div className='form_submit_box_alchemist'>
                    <button onClick={() => {
                      if(recoverNeo > 0 && recoverNeo < 101){
                        recoverMineral(3);
                      }
                    }}>Withdraw Now</button>
                </div>
                {(depositNeo > 0 && depositNeo < 101) ? null : <div className='form_errormsg_alchemsit'><span >*Withdraw amount need to be at least 1 and not exceeds of 100.</span></div>}
              </motion.div>
            : <motion.div className='form_minerals_alchemist'
                initial='initial'
                animate='show'
                exit='exit'
                variants={variant_DW}
                key={0}
              >
                <div className='form_mineral_title_alchemist'>
                  <span>Deposit Neodymium:</span>
                </div>
                <div className='form_inputs_minerals_alchemsit'>
                  <input id={1} type="number" placeholder='0 Neo' min={1} max={100} value={depositNeo} onChange={handlerCapture}/>
                  <button className='btn_max_minerals_alchemist' onClick={() => setMaxQty(1)}>Max</button>
                </div>
                <div className='form_submit_box_alchemist'>
                    <button onClick={() => {
                      if(depositNeo > 0 && depositNeo < 101){
                        depositMineral(1);
                      }
                    }}>Deposit Now</button>
                </div>
                {(depositNeo > 0 && depositNeo < 101) ? null : <div className='form_errormsg_alchemsit'><span >*Deposit amount need to be at least 1 and not exceeds of 100.</span></div>}
              </motion.div>
        }
        {(Number(stakedBalances.chal) === 100 || Number(withdraw) === 2)
          ? <motion.div className={`form_minerals_alchemist`}
              initial='initial'
              animate='show'
              exit='exit'
              variants={variant_DW}
              key={2}
            >
              <div className='form_mineral_title_alchemist'>
                <span>Withdraw Chalcedony:</span>
              </div>
              <div className='form_inputs_minerals_alchemsit'>
                <input type="number" id={4} value={recoverChal} placeholder='0 Chal' min={1} max={100} onChange={handlerCapture}/>
                <button className='btn_max_minerals_alchemist'  onClick={() => setMaxQty(4)}>Max</button>
              </div>
              <div className='form_submit_box_alchemist'>
                <button onClick={() => {
                      if(recoverChal > 0 && recoverChal < 101){
                        recoverMineral(4);
                      }
                    }}>Withdraw Now</button>
              </div>
              {((depositChal > 0 && depositChal < 101) || Number(withdraw) === 3) ? null : <div className='form_errormsg_alchemsit'><span >*Withdraw amount need to be at least 1 and not exceeds of 100.</span></div>}
            </motion.div>
          : <motion.div className='form_minerals_alchemist'
                initial='initial'
                animate='show'
                exit='exit'
                variants={variant_DW}
                key={3}
            >
              <div className='form_mineral_title_alchemist'>
                <span>Deposit Chalcedony:</span>
              </div>
              <div className='form_inputs_minerals_alchemsit'>
                <input type="number" id={2} value={depositChal} placeholder='0 Chal' min={1} max={100} onChange={handlerCapture}/>
                <button className='btn_max_minerals_alchemist'  onClick={() => setMaxQty(2)}>Max</button>
              </div>
              <div className='form_submit_box_alchemist'>
                <button onClick={() => {
                      if(depositChal > 0 && depositChal < 101){
                        depositMineral(2);
                      }
                    }}>Deposit Now</button>
              </div>
              {(depositChal > 0 && depositChal < 101) ? null : <div className='form_errormsg_alchemsit'><span >*Deposit amount need to be at least 1 and not exceeds of 100.</span></div>}
            </motion.div>
        }
        </AnimatePresence>
        {((Number(stakedBalances.neo) > 0 && Number(stakedBalances.chal) > 0) && (Number(stakedBalances.neo) === Number(stakedBalances.chal)))
            ? <div className='form_minerals_alchemist'>
                <div className='action_fuse_alchemist'>
                  <span>Ready to Transmute your Minerals?</span>
                </div>
                <div className='form_submit_box_alchemist'>
                    <button onClick={() => {
                      if(Number(stakedBalances.neo) === Number(stakedBalances.chal)){
                        transmutation();
                      }
                      }}>Transmute Now</button>
                </div>
                {(Number(stakedBalances.neo) === Number(stakedBalances.chal)) ? null : <div className='form_errormsg_alchemsit'><span >*The amount of NEO and CHAL need to be the same and at least 1.</span></div>}
              </div>
            : <motion.div className='form_minerals_alchemist'
                      initial={{y: '100px', opacity: 0}}
                      animate={{y: 0, opacity: 1}}
                      transition={{duration: 0.2, delay: 0.4}}
                >
                <div className='form_errormsg_alchemsit'>
                  <span >*The amount of NEO and CHAL need to be the same for TRANSMUTE to ONYX.</span>
                </div>
              </motion.div>
        }
      </div>
    </div>
  )
}

export const Scrapyard = ({userData, showLoader, closerLoader, pricesFees, onRefreshBalances}) => {
  
  const [pageAct, setPageAct] = useState(1);
  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
  })

  const [userItems, setUserItems] = useState([]);
  const [filters, setFilters] = useState({
    withFilters: false,
    isNation: false,
    nation: '',
    isRarity: false,
    rarity: '',
    isParts: false,
    parts: '',
    isType: false,
    type: 'blueprints',
  })
  const [itemsSelected, setItemsSelected] = useState([])

  const [refreshComp, setRefreshComp] = useState(false);
  const [toggleItems, setTogglerItems] = useState(true);
  const [readyToReward, SetReadyToReward] = useState({
    isReady: false,
    itemsQty: 0,
  })

  const scrapPrice = Number.parseFloat(pricesFees.scrapfee).toFixed(2);

  useEffect(() => {
    if(userData.isConnected){
        loadItems(filters.type);
        haveRewards();
    }

    return () => {
      // Nothing to do
    };

  }, [pageAct, userData.isConnected]);

  useEffect(() => {
    if(userData.isConnected){
      if(filters.withFilters){
        loadItemsWithFilters(filters.type);
      }
      else{
        loadItems(filters.type);
        haveRewards();
      }
    }

    return () => {
    };

  }, [pageAct, filters, (refreshComp === true)]);

  
  const haveRewards = () => {
    LoadisScrap(userData.username)
      .then(x => SetReadyToReward(x));
  }

  const loadItemsWithFilters = async(itemType) => {
    if(filters.isNation && filters.isParts){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${ExtinctionData.collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Type=${filters.parts}&data.Nation=${filters.nation}&limit=10&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const accountData = data.data;
      setUserItems(accountData);
      setRefreshComp(false);
    }
    else if(filters.isNation && filters.isRarity){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${ExtinctionData.collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Rarity=${filters.rarity}&data.Nation=${filters.nation}&limit=10&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const accountData = data.data;
      setUserItems(accountData);
      setRefreshComp(false);
    }
    else if(filters.isParts){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${ExtinctionData.collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Type=${filters.parts}&limit=10&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const accountData = data.data;
      setUserItems(accountData);
      setRefreshComp(false);
    }
    else if(filters.isRarity){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${ExtinctionData.collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Rarity=${filters.rarity}&limit=10&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const accountData = data.data;
      setUserItems(accountData);
      setRefreshComp(false);
    }
    else if(filters.isNation){
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${ExtinctionData.collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&data.Nation=${filters.nation}&limit=10&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const accountData = data.data;
      setUserItems(accountData);
      setRefreshComp(false);
    }
  }

  const loadItems = async(itemType) => {
      const api = `${ApisProvider.atomicApi}atomicassets/v1/assets?collection_name=${ExtinctionData.collectionName}&schema_name=${itemType}&owner=${userData.username}&page=${pageAct}&limit=10&order=desc&sort=asset_id`;

      const response = await fetch(api, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Origin': '*'
        }
      });
      const data = await response.json();
      const accountData = data.data;
      setUserItems(accountData);
      setRefreshComp(false);
  }

  const filterPartsCapture = (evt) => {
    const filter = evt.target.value;
    if(filter !== 'Select Type'){
      setFilters((state) => ({
        ...state,
        withFilters: true,
        isParts: true,
        parts: filter,
      }));
    }else{
      setFilters((state) => ({
        ...state,
        withFilters: false,
        isParts: false,
        parts: '',
      }));
    }
    
  }
  
  const filterNationCapture = (evt) => {
    const filter = evt.target.value;
    if(filter !== 'Select Nation'){
      setFilters((state) => ({
        ...state,
        withFilters: true,
        isNation: true,
        nation: filter,
      }));
    }else{
      setFilters((state) => ({
        ...state,
        withFilters: false,
        isNation: false,
        nation: '',
      }));
    }
  }
  
  const clearFilters = () => {
    setFilters({
      withFilters: false,
      isNation: false,
      nation: '',
      isRarity: false,
      rarity: '',
      isParts: false,
      parts: '',
      isType: false,
      type: 'blueprints',
    });
  }

  const itemSelector = (itemId) => {
      const exist = itemsSelected.includes(itemId);

      if(Number(itemsSelected.length) < 5){
        if(!exist){
          const newItem = itemId;
          setItemsSelected([...itemsSelected, newItem])
        }
        else {
          const items = [...itemsSelected].filter(x => x !== itemId);
          setItemsSelected(items);
        }
      }else{
        if(exist){
          const items = [...itemsSelected].filter(x => x !== itemId);
          setItemsSelected(items);
        }
        //console.log('max item')
        /*  */
      }
  }

  const destroyItems = async() => {
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
          account: 'atomicassets',
          name: 'transfer',
          authorization: [userData.auths],
          data: {
            from: userData.username,
            to: ExtinctionData.GEARS_CONTRACT,
            asset_ids: itemsSelected,
            memo: 'scrapyard',
          },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
        //console.log(`Transaction broadcast! Id: ${transaction.id}`);
        SetReadyToReward({
          isReady: true,
          itemsQty: itemsSelected.length,
        })
        clearSelections();
        setRefreshComp(true);
        })
      }catch(err){
        
      }
    } 
    else if(userData.whichProvider === 'WaxCloud'){
      try{
        const action = {
            actions: [{
                account: 'atomicassets',
                name: 'transfer',
                authorization: [{
                    actor: userData.username,
                    permission: 'active',
                  }],
                data: {
                  from: userData.username,
                  to: ExtinctionData.GEARS_CONTRACT,
                  asset_ids: itemsSelected,
                  memo: 'scrapyard',
                },
            }],
        }
        const transaction = await userData.sessionData.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 1200,
          });
          setNotify({
            status: true,
            error: false,
            title: 'Success',
            msg: 'Transaction Id:',
            txId: transaction.transaction_id,
          });
          SetReadyToReward({
            isReady: true,
            itemsQty: itemsSelected.length,
          })
          clearSelections();
          setRefreshComp(true);
      }
      catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
      }
    }       
  }

  const claimReward = async() => {
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
          account: ExtinctionData.GEARS_CONTRACT,
          name: 'printreward',
          authorization: [userData.auths],
          data: {
            account: userData.username,
          },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
        //console.log(`Transaction broadcast! Id: ${transaction.id}`);
        SetReadyToReward({
          isReady: false,
          itemsQty: 0,
        })
        setRefreshComp(true);
        onRefreshBalances();
        })
      }catch(err){
        
      }   
    } 
    else if(userData.whichProvider === 'WaxCloud'){
      try{
        const action = {
            actions: [{
              account: ExtinctionData.GEARS_CONTRACT,
              name: 'printreward',
                authorization: [{
                    actor: userData.username,
                    permission: 'active',
                  }],
                data: {
                  account: userData.username,
                },
            }],
        }
        const transaction = await userData.sessionData.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 1200,
          });
          setNotify({
            status: true,
            error: false,
            title: 'Success',
            msg: 'Transaction Id:',
            txId: transaction.transaction_id,
          });
          setRefreshComp(true);
          onRefreshBalances();
      }
      catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
      }
    } 
       
  }

  const clearSelections = () => setItemsSelected([]);

  const togglerInv = () => setTogglerItems(!toggleItems);

  /* ===== VARIANTS ANIMATIONS ====== */

  const items = {
    visible: x => ({
      opacity: 1,
      scale: 1,
      transition: { delay: x * 0.2, duration: 0.2 },
    }),
    hidden: {opacity: 0, scale: 0},
  }

  const itemsSel = {
    visible: x => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.2, type: 'ease'},
    }),
    hidden: {opacity: 0, y: '40%'},
  }

  const btnActions = {
    visible: {
      opacity: 1,
      scale: 1,
    },
    hidden: {
      opacity: 0,
      scale: 0,
    }
  }

  const isOpen = {
    open: {
      height: '100%',
    },
    closed: {
      height: '0',
    }
  }
  /* ===== VARIANTS ANIMATIONS ====== */

  if(!userData.isConnected){
    return (
      <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }

  return(
    <LayoutContainer>
      <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
      {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
      </div>
      <LayoutRow styles={{height: '100%'}}>
        <LayoutCol>
          <div className='inventory_container_scrapyard'>            
            <LayoutRow styles={{padding: '1rem', backgroundColor: '#232325'}}>
                  <div className='toggler_section_scrapyard'>
                    {toggleItems 
                      ? <motion.button className='btn_togglerInv_scrapyard' onClick={() => togglerInv()}
                      whileHover={{ scale: 1.2, duration: 0.2 }}
                      whileTap={{ scale: 0.5, duration: 0.2}}
                      ><FontAwesomeIcon icon={faAngleDown} size='xl'/></motion.button>
                      : <motion.button className='btn_togglerInv_scrapyard' onClick={() => togglerInv()}
                      whileHover={{ scale: 1.2, duration: 0.2 }}
                      whileTap={{ scale: 0.5, duration: 0.2}}
                    ><FontAwesomeIcon icon={faAngleUp} size='xl'/></motion.button>
                    }
                  </div>
                  <div className='controls-section'>
                    <FilterMaker filters={filters} clearFilters={clearFilters} capturerOne={filterPartsCapture} capturerTwo={filterNationCapture}/>
                    <Paginator pageAct={pageAct} setPageAct={setPageAct}/>
                  </div>
            </LayoutRow>
              <motion.div className='items_shower_box'
              animate={toggleItems ? 'open' : 'closed'}
              variants={isOpen}
              >
                
                {userItems.map((i, x) => (
                  <motion.div className='items_containers_scrapyard' key={i.asset_id}
                    custom={x}
                    initial='hidden'
                    animate='visible'
                    variants={items}
                    > 
                    {(itemsSelected.includes(i.asset_id))
                      ?<motion.button onClick={() => itemSelector(i.asset_id)} className='btn_selector_multi'
                      whileHover={{ scale: 1.2, color: '#bdbdbd', duration: 0.2 }}
                      whileTap={{ scale: 0.5, duration: 0.2}}
                      ><FontAwesomeIcon icon={faCircleCheck} size='xl'/></motion.button>
                      :<motion.button onClick={() => itemSelector(i.asset_id)} className='btn_selector_multi'
                      whileHover={{ scale: 1.2, color: '#bdbdbd', duration: 0.2}}
                      whileTap={{ scale: 0.5, duration: 0.2}}
                      ><FontAwesomeIcon icon={faCircleDot} size='xl'/></motion.button>
                    }
                    <ItemsScrapyard id={i.asset_id}/>
                  </motion.div>
                ))}
              </motion.div>
          </div>
        </LayoutCol>
        <LayoutCol>
          {readyToReward.isReady
            ? <div className='reward_shower_container_scrapyard'>
                <motion.div className='reward_container_scrapyard'
                initial={{opacity: 0, scale: 0}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.2}}
                >
                  <div className='header_text_reward_scrapyard'>
                    <h3>Well done!</h3>
                    <p>You have won {(Number(readyToReward.itemsQty) * Number(scrapPrice))} ONYX for recycling</p>
                  </div>
                  <div className='btner_footer_reward_scrapyard'>
                    <motion.button
                    whileHover={{ scale: 1.2, duration: 0.2 }}
                    whileTap={{ scale: .9, duration: 0.2}}
                    onClick={() => claimReward()}
                    >Claim Now</motion.button>
                  </div>
                </motion.div>
              </div>
            : <div className='item_shower_container_scrapyard'>
                {(Number(itemsSelected.length) > 0) &&
                  <div className='btn_container_scrapyard'>
                  <motion.button onClick={() => clearSelections()}
                  variants={btnActions}
                  initial='hidden'
                  animate='visible'
                  transition={{duration: 0.2, type: 'ease'}}
                  >Unselect {Number(itemsSelected.length) > 1 ? 'All' : ''}</motion.button>
                  <motion.button
                  variants={btnActions}
                  initial='hidden'
                  animate='visible'
                  transition={{delay: 0.3, duration: 0.2, type: 'ease'}}
                  onClick={() => destroyItems()}
                  >Destroy</motion.button>
                </div>
                }
                <>
                <div className='container_items_fixer'>
                {itemsSelected.map((i, x) => (
                    <motion.div className={`items_containers_scrapyard item_selected_scrapyard${x + 1}`} key={i}
                    custom={x + 1}
                    initial='hidden'
                    animate='visible'
                    exit={{y: '100px', opacity: 0}}
                    variants={itemsSel}
                  >
                    <ItemsScrapyard id={i}/>
                  </motion.div>
                  ))}
                </div>
                </>
              </div>
          }
        </LayoutCol>
      </LayoutRow>
    </LayoutContainer>
  )
}

export const BillysWorkshop = ({userData, showLoader, closerLoader, pricesFees, onRefreshBalances}) => {
  const [refreshComp, setRefreshComp] = useState('');
  const [nofity, setNotify] = useState({
    status: false,
    error: false,
    title: '',
    msg: '',
    txId: '',
})

  useEffect(() => {
    if(userData.isConnected){
      loadData(userData.username);
    }
    return () => {
      setHasSuit({
        isBuilding: false,
        suitBuiling: '',
        nameBuilding: '',
        helmet: '',
        chest: '',
        arms: '',
        legs: '',
      })
      setHasWeapon({
        isBuilding: false,
        weaponBuiling: '',
        barrel: '',
        body: '',
        stock: '',
        magazine: '',
      })
    }
  }, [refreshComp]);

  const [hasWeapon, setHasWeapon] = useState({
    isBuilding: false,
    weaponBuiling: '',
    barrel: '',
    body: '',
    stock: '',
    magazine: '',
  });
  const [hasSuit, setHasSuit] = useState({
    isBuilding: false,
    suitBuiling: '',
    helmet: '',
    chest: '',
    arms: '',
    legs: '',
  });

  const [inventoryParts, setIinventoryParts] = useState('');

  const [recoveryModal, setRecoveryModal] = useState({
    status: false,
    part: '',
  });

  useEffect(() => {
    if(userData.isConnected){
      loadData(userData.username);
    }
  
    return () => {
      
    }
  }, [userData.isConnected]);

  

  const loadItem = async(id, type) => {
    const api = `${ApisProvider.atomicApi}atomicassets/v1/assets/${id}`;
    const response = await fetch(api, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Origin': '*'
        }
    });
    const data = await response.json();
    const assetData = data.data;
    
    if(type === 'helmet'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.helmets.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasSuit((state) => ({
          ...state,
          isBuilding: true,
          suitBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          helmet: itemSelected,
        }))
      }
    }
    else if(type === 'chest'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.chests.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasSuit((state) => ({
          ...state,
          isBuilding: true,
          suitBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          chest: itemSelected,
        }))
      }
    }
    else if(type === 'arms'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.arms.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasSuit((state) => ({
          ...state,
          isBuilding: true,
          suitBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          arms: itemSelected,
        }))
      }
    }
    else if(type === 'legs'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.legs.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasSuit((state) => ({
          ...state,
          isBuilding: true,
          suitBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          legs: itemSelected,
        }))
      }
    }
    else if(type === 'barrel'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.barrels.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasWeapon((state) => ({
          ...state,
          isBuilding: true,
          weaponBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          barrel: itemSelected,
        }))
      }
    }
    else if(type === 'body'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.bodies.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasWeapon((state) => ({
          ...state,
          isBuilding: true,
          weaponBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          body: itemSelected,
        }))
      }
    }
    else if(type === 'stock'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.stocks.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasWeapon((state) => ({
          ...state,
          isBuilding: true,
          weaponBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          stock: itemSelected,
        }))
      }
    }
    else if(type === 'magazine'){
      if(assetData !== undefined){
        const itemSelected = ItemsData.blueprints.magazines.find(x => Number(x.templateId) === Number(assetData.template.template_id));
        setHasWeapon((state) => ({
          ...state,
          isBuilding: true,
          weaponBuiling: itemSelected.itemToBuild,
          nameBuilding: itemSelected.block_name,
          magazine: itemSelected,
        }))
      }
    }
  }

  const loadData = async(username) => {
    LoadWorkshopData(username)
    .then(x => {
      if(x.resultSuit !== undefined){
          const {resultSuit} = x;

          if(Number(resultSuit.hashelmet) === 1){
            loadItem(resultSuit.helmetid, 'helmet');
          }
          if(Number(resultSuit.haschest) === 1){
            loadItem(resultSuit.chestid, 'chest');
          }
          if(Number(resultSuit.hasarm) === 1){
            loadItem(resultSuit.armid, 'arms');
          }
          if(Number(resultSuit.haslegs) === 1){
            loadItem(resultSuit.legsid, 'legs');
          }
      }

      if(x.resultWeapon !== undefined){
        const {resultWeapon} = x;

        if(Number(resultWeapon.hasbarrel) === 1){
          loadItem(resultWeapon.barrelid, 'barrel');
        }
        if(Number(resultWeapon.hasbody) === 1){
          loadItem(resultWeapon.bodyid, 'body');
        }
        if(Number(resultWeapon.hasstock) === 1){
          loadItem(resultWeapon.stockid, 'stock');
        }
        if(Number(resultWeapon.hasmagazine) === 1){
          loadItem(resultWeapon.magazineid, 'magazine');
        }
      }
    })
  }
 
  const addItem = async(id, part) => {
    if(userData.whichProvider === 'Anchor'){
      if(part === 'Helmet'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Helmet`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(transaction.id.toString());
          })
        }
        catch(err){
        
        }
      }
      else if(part === 'Chest'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Chest`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(transaction.id.toString());
          })
        }
        catch(err){
        
        }
      }
      else if(part === 'Arms'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Arms`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(true);
          })
        }
        catch(err){
        
        }
      }
      else if(part === 'Legs'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Legs`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(transaction.id.toString());
          })
        }
        catch(err){
        
        }
      }
      else if(part === 'Barrel' || part === 'Pen'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Barrel`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(transaction.id.toString());
          })
        }
        catch(err){
        
        }
      }
      else if(part === 'Bodygun' || part === 'Handle'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Bodygun`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(transaction.id.toString());
          })
        }
        catch(err){
        
        }
      }
      else if(part === 'Stock' || part === 'Face'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Stock`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(transaction.id.toString());
          })
        }
        catch(err){
        
        }
      }
      else if(part === 'Magazine' || part === 'Cheek'){
        try{
          const action = {
              account: 'atomicassets',
              name: 'transfer',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                asset_ids: [id],
                memo: `Workshop Magazine`,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          inventoryCloser();
          setRefreshComp(transaction.id.toString());
          })
        }
        catch(err){
        
        }
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      if(part === 'Helmet'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Helmet`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      else if(part === 'Chest'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Chest`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                    status: true,
                    error: true,
                    title: 'failed transaction',
                    msg: msgError,
                });
        }
      }
      else if(part === 'Arms'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Arms`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      else if(part === 'Legs'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Legs`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      else if(part === 'Barrel' || part === 'Pen'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Barrel`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      else if(part === 'Bodygun' || part === 'Handle'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Bodygun`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      else if(part === 'Stock' || part === 'Face'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Stock`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      else if(part === 'Magazine' || part === 'Cheek'){
        try{
          const action = {
              actions: [{
                  account: 'atomicassets',
                  name: 'transfer',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                    to: ExtinctionData.EXTINCTION_CONTRACT,
                    asset_ids: [id],
                    memo: `Workshop Magazine`,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
            inventoryCloser();
            setRefreshComp(transaction.transaction_id);
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
    }
  }

  const craftItem = async(type) => {
    if(userData.whichProvider === 'Anchor'){
      if(type === 'suit'){
        try{
          const action = {
              account: ExtinctionData.ONYX_CONTRACT,
              name: 'craftsuit',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                quantity: pricesFees.craftsuitfee,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          setRefreshComp(transaction.id.toString());
          onRefreshBalances();
          })
        }
        catch(err){
        
        }
      }
      if(type === 'weapon'){
        try{
          const action = {
              account: ExtinctionData.ONYX_CONTRACT,
              name: 'craftwep',
              authorization: [userData.auths],
              data: {
                from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                quantity: pricesFees.craftwepfee,
              },
          }
          userData.sessionData.transact({action}).then(({transaction}) => {
          //console.log(`Transaction broadcast! Id: ${transaction.id}`);
          setRefreshComp(transaction.id.toString());
          onRefreshBalances();
          })
        }
        catch(err){
        
        }
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      if(type === 'suit'){
        try{
          const action = {
              actions: [{
                account: ExtinctionData.ONYX_CONTRACT,
                name: 'craftsuit',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                quantity: pricesFees.craftsuitfee,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
          setRefreshComp(transaction.transaction_id);
          onRefreshBalances();
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
      if(type === 'weapon'){
        try{
          const action = {
              actions: [{
                account: ExtinctionData.ONYX_CONTRACT,
                name: 'craftwep',
                  authorization: [{
                      actor: userData.username,
                      permission: 'active',
                    }],
                  data: {
                    from: userData.username,
                to: ExtinctionData.EXTINCTION_CONTRACT,
                quantity: pricesFees.craftwepfee,
                  },
              }],
          }
          const transaction = await userData.sessionData.api.transact(action, {
              blocksBehind: 3,
              expireSeconds: 1200,
            });
            setNotify({
              status: true,
              error: false,
              title: 'Success',
              msg: 'Transaction Id:',
              txId: transaction.transaction_id,
            });
          setRefreshComp(transaction.transaction_id);
          onRefreshBalances();
        }
        catch(err){
              const msgError = err.message.split('assertion failure with message: ').join('')
              setNotify({
                status: true,
                error: true,
                title: 'failed transaction',
                msg: msgError,
            });
        }
      }
    }
  }

  const recoveryItem = async(part) => {
    if(userData.whichProvider === 'Anchor'){
      try{
        const action = {
            account: ExtinctionData.EXTINCTION_CONTRACT,
            name: 'recoverprint',
            authorization: [userData.auths],
            data: {
              account: userData.username,
              printtype: part,
            },
        }
        userData.sessionData.transact({action}).then(({transaction}) => {
        //console.log(`Transaction broadcast! Id: ${transaction.id}`);
        recoveryPart('');
        setRefreshComp(transaction.id.toString());
        })
      }
      catch(err){
      
      }
    }
    else if(userData.whichProvider === 'WaxCloud'){
      try{
        const action = {
            actions: [{
              account: ExtinctionData.EXTINCTION_CONTRACT,
            name: 'recoverprint',
                authorization: [{
                    actor: userData.username,
                    permission: 'active',
                  }],
                data: {
                  account: userData.username,
                  printtype: part,
                },
            }],
        }
        const transaction = await userData.sessionData.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 1200,
          });
          setNotify({
            status: true,
            error: false,
            title: 'Success',
            msg: 'Transaction Id:',
            txId: transaction.transaction_id,
          });
          recoveryPart('');
          setRefreshComp(transaction.transaction_id);
      }
      catch(err){
            const msgError = err.message.split('assertion failure with message: ').join('')
            setNotify({
              status: true,
              error: true,
              title: 'failed transaction',
              msg: msgError,
          });
      }
    }
  } 

  const inventoryOpener = (parts) => setIinventoryParts(parts);

  const inventoryCloser = () => setIinventoryParts('');

  const recoveryPart = (part) => {
    if(recoveryModal.status === true){
      setRecoveryModal({
        status:false,
        part: part,
      })
    }
    else{
      setRecoveryModal({
        status: true,
        part: part,
      })
    }
  };




  if(!userData.isConnected){
    return (
      <div className='signIn_box'>
            <h2 className='signIn-letter'>You need to sign in before!</h2>
        </div>
    )
  }

  if(showLoader){
    return (
      <div className='loader_animation'>
        <VideoLoader url={ExtinctionVideoData.loader} url2={ExtinctionVideoData.loaderMobile} autoClose={closerLoader}/>
      </div>
    )
  }
  
  return (
    <LayoutContainer>
      {recoveryModal.status && <ModalBtn part={recoveryModal.part} title={`Are you sure to recovery ${recoveryModal.part}?`} action={recoveryItem} closeModal={recoveryPart}/>}
      {inventoryParts === 'helmet' && <InventoryParts userData={userData} type={'blueprints'} part={'Helmet'} onSelect={addItem} closer={inventoryCloser} itemChecker={hasSuit} moduleType={'suit'}/>}
      {inventoryParts === 'chest' && <InventoryParts userData={userData} type={'blueprints'} part={'Chest'} onSelect={addItem} closer={inventoryCloser} itemChecker={hasSuit} moduleType={'suit'}/>}
      {inventoryParts === 'arms' && <InventoryParts userData={userData} type={'blueprints'} part={'Arms'} onSelect={addItem} closer={inventoryCloser} itemChecker={hasSuit} moduleType={'suit'}/>}
      {inventoryParts === 'legs' && <InventoryParts userData={userData} type={'blueprints'} part={'Legs'} onSelect={addItem} closer={inventoryCloser} itemChecker={hasSuit} moduleType={'suit'}/>}
      {inventoryParts === 'barrel' && <InventoryParts userData={userData} type={'blueprints'} part={'Barrel'} melee={'Pen'} onSelect={addItem} closer={inventoryCloser} itemChecker={hasWeapon} moduleType={'weapon'}/>}
      {inventoryParts === 'body' && <InventoryParts userData={userData} type={'blueprints'} part={'Bodygun'} melee={'Handle'}  onSelect={addItem} closer={inventoryCloser} itemChecker={hasWeapon} moduleType={'weapon'}/>}
      {inventoryParts === 'stock' && <InventoryParts userData={userData} type={'blueprints'} part={'Stock'} melee={'Face'} onSelect={addItem} closer={inventoryCloser} itemChecker={hasWeapon} moduleType={'weapon'}/>}
      {inventoryParts === 'magazine' && <InventoryParts userData={userData} type={'blueprints'} part={'Magazine'}  melee={'Cheek'} onSelect={addItem} closer={inventoryCloser} itemChecker={hasWeapon} moduleType={'weapon'}/>}
      <div className='workshop_container_main'>
      {nofity.status && <ModalNotify notify={nofity} closeNotify={() => {
                setNotify({
                    status: false,
                    error: false,
                    title: '',
                    msg: '',
                    txId: '',
                })
              }}/>}
        <div className='suit_builder_container'>
          <div className='item_socket_container'>
            <div className='item_socket_box' id='helmet' onClick={() => {
              if(!hasSuit.helmet){
                inventoryOpener('helmet');
              }
              else{
                recoveryPart('Helmet');
              }
            }}>
              {hasSuit.helmet
                ? <img src={hasSuit.helmet.img} alt={hasSuit.helmet.name} />
                :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
              }
            </div>
            <div className='item_socket_box' id='chest' onClick={() => {
              if(!hasSuit.chest){
                inventoryOpener('chest');
              }
              else{
                recoveryPart('Chest');
              }
            }}>
              {hasSuit.chest
                ? <img src={hasSuit.chest.img} alt={hasSuit.chest.name} />
                :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
              }
            </div>
            <div className='item_socket_box' id='arms' onClick={() => {
              if(!hasSuit.arms){
                inventoryOpener('arms');
              }
              else{
                recoveryPart('Arms');
              }
            }}>
              {hasSuit.arms
                ? <img src={hasSuit.arms.img} alt={hasSuit.arms.name} />
                :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
              }
            </div>
            <div className='item_socket_box' id='legs' onClick={() => {
              if(!hasSuit.legs){
                inventoryOpener('legs');
              }
              else{
                recoveryPart('Legs');
              }
            }}>
              {hasSuit.legs
                ? <img src={hasSuit.legs.img} alt={hasSuit.legs.name} />
                :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
              }
            </div>
          </div>
          <div className='item_view_container'>
            {hasSuit.isBuilding
              ? <>
                  {(hasSuit.helmet && hasSuit.chest && hasSuit.arms && hasSuit.legs) &&
                    <button className='btn_crafter_bp' onClick={() => craftItem('suit')}>Craft Suit</button>}
                  <video className='item_view_video' src={hasSuit.suitBuiling} autoPlay muted loop/>
                </>
              : <video src={'https://extinctionwars.com/assets/videos/visuals/menu-items/no_item.webm'} typeof='video/webm' autoPlay muted loop className='item_view_video' alt={'Test'}/>
            }
          </div>
        </div>
        <div className='weapon_builder_container'>
          <div className='item_socket_container'>
              <div className='item_socket_box' id='barrel' onClick={() => {
                if(!hasWeapon.barrel){
                  inventoryOpener('barrel')
                }
                else{
                  recoveryPart('Barrel');
                }
                }}>
                {hasWeapon.barrel
                  ? <img src={hasWeapon.barrel.img} alt={hasWeapon.barrel.name} />
                  :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
                }
              </div>
              <div className='item_socket_box' id='body' onClick={() => {
                  if(!hasWeapon.body){
                    inventoryOpener('body')
                  }
                  else{
                    recoveryPart('Bodygun');
                  }
                }}>
                {hasWeapon.body
                  ? <img src={hasWeapon.body.img} alt={hasWeapon.body.name} />
                  :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
                }
              </div>
              <div className='item_socket_box' id='stock' onClick={() => {
                if(!hasWeapon.stock){
                  inventoryOpener('stock')
                }
                else{
                  recoveryPart('Stock');
                }
              }}>
                {hasWeapon.stock
                  ? <img src={hasWeapon.stock.img} alt={hasWeapon.stock.name} />
                  :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
                }
              </div>
              <div className='item_socket_box' id='magazine' onClick={() => {
                if(!hasWeapon.magazine){
                  inventoryOpener('magazine')
                }
                else{
                  recoveryPart('Magazine');
                }
              }}>
                {hasWeapon.magazine
                  ? <img src={hasWeapon.magazine.img} alt={hasWeapon.magazine.name} />
                  :<FontAwesomeIcon icon={faPlus} size={'2xl'} color='#fff515'/>
                }
              </div>
          </div>
          <div className='item_view_container'>
            {hasWeapon.isBuilding
                ? <>
                    {(hasWeapon.barrel && hasWeapon.body && hasWeapon.stock && hasWeapon.magazine) &&
                    <button className='btn_crafter_bp' onClick={() => craftItem('weapon')}>Craft Weapon</button>}
                    <video className='item_view_video' src={hasWeapon.weaponBuiling} autoPlay muted loop/>
                  </>
                : <video src={'https://extinctionwars.com/assets/videos/visuals/menu-items/no_item.webm'} typeof='video/webm' autoPlay muted loop className='item_view_video' alt={'Test'}/>
            }
          </div>
        </div>
      </div>
    </LayoutContainer>
  )
}